// src/components/layout/Layout.jsx
import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom'; // Import routing components
import Header from './Header';
import Sidebar from './Sidebar';
import { useAppContext } from '../../context/AppContext';
// import ProgramDetails from '../program/ProgramDetails'; // No longer needed here
import ProgramDetailsPage from '../../pages/ProgramDetailsPage'; // Import the new page component
import HomePage from '../../pages/HomePage'; // Import the new home page component
import LineupsPage from '../../pages/LineupsPage';
import SaveButton from '../common/SaveButton';
import SportsOrgsPage from '../../pages/SportsOrgsPage';
import CelebritiesPage from '../../pages/CelebritiesPage';
import CelebritiesBrowsePage from '../../pages/CelebritiesBrowsePage'; // Import the new page
import MainSearchResults from '../../pages/MainSearchResults';
import CompareProgramsPage from '../../pages/CompareProgramsPage';
import SettingsModal from '../settings/SettingsModal';
import MyAccountModal from '../settings/MyAccountModal';
import StationDetailsPage from '../../pages/StationDetailsPage'; // Import Station Details
import ProgramAiringsPage from '../../pages/ProgramAiringsPage'; // Import Program Airings
import SchedulesPage from '../../pages/SchedulesPage'; // Import Schedules
import ProgramAvailabilityPage from '../../pages/ProgramAvailabilityPage'; // Import Program Availability
import SavedItemsPage from '../../pages/SavedItemsPage'; // Import Saved Items
import AdminBackendsPage from '../../pages/AdminBackendsPage'; // Import Admin Backends
import AdminCarriersPage from '../../pages/AdminCarriersPage'; // Import Admin Carriers
import AdminUsersPage from '../../pages/AdminUsersPage'; // Import Admin Users
import AdminPermissionsPage from '../../pages/AdminPermissionsPage'; // Import Admin Permissions
import AdminCarrierPermissionsPage from '../../pages/AdminCarrierPermissionsPage'; // Import Admin Carrier Permissions
import CarrierUsersPage from '../../pages/CarrierUsersPage'; // Import Carrier Users Management
import TelusPage from '../../pages/TelusPage'; // Import TelusPage
import DataKpiPage from '../../pages/DataKpiPage'; // Import Data KPI Page
import PrivacyPage from '../../pages/PrivacyPage'; // Import Privacy Page
import TermsPage from '../../pages/TermsPage'; // Import Terms Page
import Footer from './Footer'; // Import Footer

const Layout = () => {
  const { isSettingsModalOpen, isMyAccountModalOpen, closeMyAccountModal } = useAppContext(); // Get modal states and functions
  const location = useLocation(); // Get current location

  // Check if the current path is a program details page
  const isProgramDetailsPage = location.pathname.startsWith('/program/');

  return (
    <div className="flex h-screen w-full bg-gray-100 text-gray-800 overflow-hidden" style={{ minWidth: '1100px' }}>
      <Header />
      <Sidebar /> {/* Sidebar might need updates later to use <Link> */}
      
      {/* Main content area where routes will render */}
      <div className="flex-1 pt-10 pb-8 overflow-hidden flex flex-col">
        <Routes>
          <Route path="/" element={<HomePage />} /> {/* Default route */}
          <Route path="/results" element={<MainSearchResults />} />
          <Route path="/search-results" element={<MainSearchResults />} />
          {/* Lineups Routes */}
          <Route path="/lineups" element={<LineupsPage />} />
          <Route path="/lineups/:lineupId" element={<LineupsPage />} />
          <Route path="/lineups/:lineupId/channels/:channelId" element={<LineupsPage />} />
          <Route path="/lineups/:lineupId/channels/:channelId/schedules/:scheduleId" element={<LineupsPage />} />
          {/* End Lineups Routes */}
          <Route path="/sports" element={<SportsOrgsPage />} />
          <Route path="/sports/:genreName/:orgName" element={<SportsOrgsPage />} />
          <Route path="/celebrities" element={<CelebritiesPage />} /> {/* Existing celebrity search */}
          <Route path="/celebrities/:personId" element={<CelebritiesPage />} /> {/* Celebrity details by personId */}
          <Route path="/celebrities/browse" element={<CelebritiesBrowsePage />} /> {/* New celebrity browse */}
          <Route path="/compare" element={<CompareProgramsPage />} />
          <Route path="/program/:programId" element={<ProgramDetailsPage />} /> {/* New route */}
          {/* Added routes for previously placeholder pages */}
          <Route path="/station-details" element={<StationDetailsPage />} />
          <Route path="/program-airings" element={<ProgramAiringsPage />} />
          <Route path="/schedules" element={<SchedulesPage />} />
          <Route path="/program-availability" element={<ProgramAvailabilityPage />} />
          <Route path="/saved-items" element={<SavedItemsPage />} />
          {/* Admin Routes */}
          <Route path="/admin/backends" element={<AdminBackendsPage />} />
          <Route path="/admin/carriers" element={<AdminCarriersPage />} />
          <Route path="/admin/users" element={<AdminUsersPage />} />
          <Route path="/admin/permissions" element={<AdminPermissionsPage />} />
          <Route path="/admin/carrier-permissions" element={<AdminCarrierPermissionsPage />} />
          {/* Carrier Management Routes */}
          <Route path="/carrier/users" element={<CarrierUsersPage />} />
          {/* Telus Routes */}
          <Route path="/telus" element={<TelusPage />} />
          {/* Data Routes */}
          <Route path="/data/kpi" element={<DataKpiPage />} />
          {/* Privacy and Terms Routes */}
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          {/* Add a catch-all or 404 route if desired */}
          <Route path="*" element={
            <div className="flex items-center justify-center h-full">
              <div className="text-center p-12 bg-white rounded-lg shadow-sm">
                <h2 className="text-xl font-semibold mb-4">Page Not Found</h2>
                <p className="text-gray-600">The requested page does not exist.</p>
              </div>
            </div>
          } />
        </Routes>
      </div>
      
      {/* Save button (floating) - Show only on program details pages */}
      {isProgramDetailsPage && <SaveButton />}

      {/* Conditionally render the Settings Modal */}
      {isSettingsModalOpen && <SettingsModal />}
      
      {/* Conditionally render the My Account Modal */}
      {isMyAccountModalOpen && <MyAccountModal isOpen={isMyAccountModalOpen} onClose={closeMyAccountModal} />}

      {/* Footer with Privacy and Terms links */}
      <Footer />
    </div>
  );
};

export default Layout;
